import { defineMessages } from 'react-intl'

export default defineMessages({
  appSuccessTitle: {
    id: 'app.successTitle',
    defaultMessage: 'Success',
  },
  appErrorTitle: {
    id: 'app.errorTitle',
    defaultMessage: 'Error',
  },
  appErrorDescription: {
    id: 'app.errorDescription',
    defaultMessage: 'Something went wrong. Please try again.',
  },
  appCookiesRequiredMessage: {
    id: 'app.cookies.required.message',
    defaultMessage: 'Cookies are required, please enable cookies in your browser.',
  },
  appUsersYou: {
    id: 'app.users.you',
    defaultMessage: 'You',
  },
  appUsersAdmin: {
    id: 'app.users.admin',
    defaultMessage: 'Admin',
  },
  appUsersUser: {
    id: 'app.users.user',
    defaultMessage: 'User',
  },
  appGlobalNext: {
    id: 'app.global.next',
    defaultMessage: 'Next',
  },
  appGlobalAdd: {
    id: 'app.global.add',
    defaultMessage: 'Add',
  },
  appGlobalEdit: {
    id: 'app.global.edit',
    defaultMessage: 'Edit',
  },
  appGlobalSave: {
    id: 'app.global.save',
    defaultMessage: 'Save',
  },
  appGlobalChange: {
    id: 'app.global.change',
    defaultMessage: 'Change',
  },
  appGlobalClose: {
    id: 'app.global.close',
    defaultMessage: 'Close',
  },
  appGlobalDone: {
    id: 'app.global.done',
    defaultMessage: 'Done',
  },
  appGlobalSend: {
    id: 'app.global.send',
    defaultMessage: 'Send',
  },
  appGlobalBack: {
    id: 'app.global.back',
    defaultMessage: 'Back',
  },
  appGlobalRename: {
    id: 'app.global.rename',
    defaultMessage: 'Rename',
  },
  appGlobalDelete: {
    id: 'app.global.delete',
    defaultMessage: 'Delete',
  },
  appGlobalRemove: {
    id: 'app.global.remove',
    defaultMessage: 'Remove',
  },
  appGlobalDownload: {
    id: 'app.global.download',
    defaultMessage: 'Download',
  },
  appGlobalExport: {
    id: 'app.global.export',
    defaultMessage: 'Export',
  },
  appGlobalExportAll: {
    id: 'app.global.exportAll',
    defaultMessage: 'Export all',
  },
  appGlobalExportConfirmationTitle: {
    id: 'app.global.export.confirmation.title',
    defaultMessage: 'Export to ZIP',
  },
  appGlobalExportConfirmationMessage: {
    id: 'app.global.export.confirmation.message',
    defaultMessage: 'The exported data will be sent to {email} when it gets processed.',
  },
  appGlobalExportSuccessMessage: {
    id: 'app.global.export.success.message',
    defaultMessage: 'The exported data will be sent when it gets processed.',
  },
  appGlobalConfirmTitle: {
    id: 'app.global.confirmTitle',
    defaultMessage: 'Are you sure?',
  },
  appGlobalCancel: {
    id: 'app.global.cancel',
    defaultMessage: 'Cancel',
  },
  appGlobalConfirm: {
    id: 'app.global.confirm',
    defaultMessage: 'Confirm',
  },
  appGlobalAccept: {
    id: 'app.global.accept',
    defaultMessage: 'Accept',
  },
  appGlobalBoolYes: {
    id: 'app.global.bool.yes',
    defaultMessage: 'Yes',
  },
  appGlobalBoolNo: {
    id: 'app.global.bool.no',
    defaultMessage: 'No',
  },
  appGlobalNavNavigateAwayNotice: {
    id: 'app.global.nav.navigateAwayNotice',
    defaultMessage: 'Are you sure you want to navigate away from this page?',
  },
  picturesPhoto: {
    id: 'app.pictures.photo',
    defaultMessage: 'Photo',
  },
  picturesAddPhoto: {
    id: 'app.pictures.addPhoto',
    defaultMessage: 'Add photo',
  },
  picturesUploading: {
    id: 'app.pictures.uploading',
    defaultMessage: 'Uploading...',
  },
  picturesUpload: {
    id: 'app.pictures.upload',
    defaultMessage: 'Upload',
  },
  picturesUploadFailedWrongFileType: {
    id: 'app.pictures.wrongFileType',
    defaultMessage: 'File type not allowed',
  },
  picturesUploadFailed: {
    id: 'app.pictures.uploadFailed',
    defaultMessage: 'Something went wrong, please try again.',
  },
  picturesDropHere: {
    id: 'app.pictures.dropHere',
    defaultMessage: 'Drop here',
  },
  appGlobalNoResults: {
    id: 'app.global.noResults',
    defaultMessage: 'No results found',
  },
  appGlobalIAgree: {
    id: 'app.global.IAgree',
    defaultMessage: 'I Agree',
  },
  appGlobalPhonesCall: {
    id: 'app.global.phones.call',
    defaultMessage: 'Call',
  },
  appGlobalPhonesPhone: {
    id: 'app.global.phones.phone',
    defaultMessage: 'Phone',
  },
  appGlobalPhonesClaimsPhone: {
    id: 'app.global.phones.claimsPhone',
    defaultMessage: 'Claims Phone',
  },
  appGlobalPhonesEmergencyPhone: {
    id: 'app.global.phones.emergencyPhone',
    defaultMessage: 'Emergency Phone',
  },
  appGlobalEmail: {
    id: 'app.global.email',
    defaultMessage: 'Email',
  },
  appGlobalErrorEmailIsRequired: {
    id: 'app.global.formError.emailIsRequired',
    defaultMessage: 'Email is required',
  },
  appGlobalErrorEmailNotValid: {
    id: 'app.global.formError.emailNotValid',
    defaultMessage: 'The input is not valid email',
  },
  appGlobalMap: {
    id: 'app.global.map',
    defaultMessage: 'Map',
  },
  appGlobalDirections: {
    id: 'app.global.directions',
    defaultMessage: 'Directions',
  },
  appGlobalClosed: {
    id: 'app.global.closed',
    defaultMessage: 'Closed',
  },
  appGlobalWeekDaysMon: {
    id: 'app.global.weekDays.mon',
    defaultMessage: 'Mon',
  },
  appGlobalWeekDaysTue: {
    id: 'app.global.weekDays.tue',
    defaultMessage: 'Tue',
  },
  appGlobalWeekDaysWed: {
    id: 'app.global.weekDays.wed',
    defaultMessage: 'Wed',
  },
  appGlobalWeekDaysThu: {
    id: 'app.global.weekDays.thu',
    defaultMessage: 'Thu',
  },
  appGlobalWeekDaysFri: {
    id: 'app.global.weekDays.fri',
    defaultMessage: 'Fri',
  },
  appGlobalWeekDaysSat: {
    id: 'app.global.weekDays.sat',
    defaultMessage: 'Sat',
  },
  appGlobalWeekDaysSun: {
    id: 'app.global.weekDays.sun',
    defaultMessage: 'Sun',
  },
  altScreenshot: {
    id: 'app.altText.screenshot',
    defaultMessage: 'Phone Screenshot',
  },
  altIconKiosk: {
    id: 'app.altText.iconKiosk',
    defaultMessage: 'Icon',
  },
  altDriverLicense: {
    id: 'app.altText.driverLicense',
    defaultMessage: 'Driver license',
  },
  altOtherDriverLicense: {
    id: 'app.altText.otherDriverLicense',
    defaultMessage: 'Other driver license',
  },
})
